import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { BaseContainer } from 'secondstep-components'
import { Link } from 'react-router-dom'
import ReactMarkdown from 'react-markdown'

export const HeaderParagraph = styled(ReactMarkdown)`
  color: ${themeGet('colors.darkGray')};
  font-family: ${themeGet('fontFamily')};
  font-size: 1rem;
  margin-top: 0.75rem;
  p {
    margin: 0;
  }

  a {
    color: ${themeGet('colors.darkGray')};
  }
`

export const Header2 = styled.p`
  color: ${themeGet('tieredInterventionUnitCard.header2.color')};
  font-family: ${themeGet('font.sharpSlab.bold')};
  font-weight: bold;
  font-size: 1.25rem;
  margin: 0;
`

export const StyledContainer = styled(BaseContainer).attrs(() => ({
  as: 'section',
}))`
  margin-top: 1.25rem;
  padding: 1.75rem;
  max-width: 85.375rem;
  border: 2px solid
    ${themeGet(
      'tieredInterventionUnitCard.styledContainer.borderColor.primary',
    )};

  position: relative;
  &:hover {
    border: 2px solid
      ${themeGet(
        'tieredInterventionUnitCard.styledContainer.borderColor.hover',
      )};
  }
  ${themeGet('breakpoints.mobileLarge')} {
    padding: 1.75rem 1rem;
  }
`

export const StyledLinkWrapper = styled(Link)`
  text-decoration: none;
`

export const MainLayoutContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
`

export const ContentWrapper = styled.div`
  flex: 1;
`

export const CompletionCircle = styled.div`
  width: 1.0625rem;
  height: 1.0625rem;
  border-radius: 50%;
  border: 1.5px solid
    ${themeGet(
      'tieredInterventionUnitCard.completionCircle.borderColor.primary',
    )};
  background-color: ${props =>
    props.markedComplete
      ? themeGet(
          'tieredInterventionUnitCard.completionCircle.borderColor.primary',
        )
      : themeGet('colors.paleGray')};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  align-self: center;
`

export const CompletionCheckmark = styled.img`
  width: 0.75rem;
  height: 0.75rem;
`

export const HeaderTagsContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  flex-wrap: wrap;
`

export const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`

export const Tag = styled.div`
  color: ${themeGet('colors.darkGray')};
  padding: 0.25rem 0.5rem;
  font-weight: 500;
  font-family: ${themeGet('font.molde.regular')};
  line-height: 1;
  letter-spacing: 1px;
`

export const TagText = styled.span`
  color: ${themeGet('colors.darkGray')};
  font-size: 0.75rem;
  background-color: ${themeGet(
    'tieredInterventionUnitCard.tagText.backgroundColor',
  )};
  padding: 0.25rem 0.5rem;
  border-radius: 0.625rem;
  height: 1.3125rem;
  width: 5.625rem;
`
